export const Configuration = {
  apiUri: process.env.REACT_APP_API_URI,
};
